import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import NoSearchResult from "../../../../components/Common/NoSearchResult";
import type { StatusPoint } from "./types";

interface StatusCardProps {
  statusSeries: number[];
  statusOptions: any;
  rows: StatusPoint[];
  formatNumber: (value?: number | string) => string;
}

const StatusCard: React.FC<StatusCardProps> = ({
  statusSeries,
  statusOptions,
  rows,
  formatNumber,
}) => {
  return (
    <Card>
      <CardHeader>
        <h4 className="card-title mb-0">Status distribution</h4>
      </CardHeader>
      <CardBody>
        {statusSeries.length > 0 ? (
          <>
            <ReactApexChart
              options={statusOptions}
              series={statusSeries}
              type="donut"
              height={320}
            />
            <div className="table-responsive mt-2">
              <table className="table table-sm table-striped mb-0">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th className="text-end">Order days</th>
                    <th className="text-end">Leads</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.status}>
                      <td>{row.label}</td>
                      <td className="text-end">{formatNumber(row.total_days)}</td>
                      <td className="text-end">{formatNumber(row.total_leads)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="text-muted small mt-2">
              Order days = number of order records per day in the selected range.
            </div>
          </>
        ) : (
          <NoSearchResult text="No status data" />
        )}
      </CardBody>
    </Card>
  );
};

export default StatusCard;
